import React, { type ReactNode } from 'react';
import { type Maybe } from '@gql/schema';
import { Typography, TypographyVariant } from '@secretescapes/falcon';
import { type SectionId } from '../Navigation';
import { SectionContainer } from './Section.styles';

export interface SectionProps {
  className?: string;
  children: ReactNode;
  id?: SectionId;
  applyRef?: (id: SectionId, element: Maybe<HTMLElement>) => void;
  title?: string;
}

export const Section = ({ className, id, applyRef, title, children }: SectionProps) => {
  return (
    <SectionContainer className={className} id={id} ref={el => id && applyRef?.(id, el)}>
      {title && <Typography variant={TypographyVariant.t4SansBold}>{title}</Typography>}
      {children}
    </SectionContainer>
  );
};
